import React from 'react'
import { Panel, Container, Button, Label } from '@sencha/ext-modern'
import { connect } from 'react-redux'
import { compose } from 'redux'
import MessageTitle from './MessageTitle'
import Message from '../../components/Message'
import { doGetAllTaskList, doSubmitTask } from '../../reducers/actions'
import './css/DetailTask.css';
import TreeListView from '../../components/TreeListView'
import { getUrl } from 'tyan/public'

Ext.require('Ext.MessageBox')

const typesOfShowFile = [
	//  'pdf',
	// 'png',
	// 'jpg'
]

class DetailTask extends React.Component {
	state = {
		allTaskList: null,
	}
	componentDidMount() {
		console.log('componentDidMount')
		const { match: { params: { title, id, type } }, doGetAllTaskList } = this.props
		doGetAllTaskList({
			title, id, type,
			onRequest: () => {
				this.setState({ loading: true })
			},
			onEnd: ({ errorMessage, allTaskList }) => {
				errorMessage && this.setState({ loading: false, errorMessage }) ||
					this.setState({ loading: false, allTaskList })
			}
		})
	}

	handleBack = () => {
		location.hash = `/QYWX/EngineeringBusinessApproval`
	}

	handleConfirm = (task, result) => (buttonId, value) => {
		const { doSubmitTask } = this.props
		// console.log('这个函数有时候不会被触发，也许是Ext的bug')
		if (buttonId === 'ok') {
			doSubmitTask({ task, comment: value, result, onSuccess: () => this.handleBack() })
		}
	}

	showFile = ({ path, ext }) => {
		if (!typesOfShowFile.includes(ext.toLowerCase())) {
			location.href = getUrl(path)
		} else {
			location.hash = '/QYWX/ShowFile/' + encodeURIComponent(path) + '/' + encodeURIComponent(ext.toLowerCase())
		}
	}

	getShowMsgHandler = (task, title, result) => () => Ext.Msg.show({
		title,
		message: '请填写审批意见',
		buttons: [{
			itemId: 'ok',
			text: '确认' + result,
		}, {
			itemId: 'cancel',
			text: '取消',
		}],
		prompt: {},
		fn: this.handleConfirm(task, result)
	})

	showTask = task => {
		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}
		return (
			<Panel layout="vbox" {...panelProps} scrollable={true}>
				<h2>【{task.title}】<small>{task.number}</small></h2>
				<Container layout={{ type: 'hbox', pack: 'start' }}>
					<Button text={`提交人：${task.name}`} />
					<Button text={`提交时间： ${task.date}`} />
				</Container>
				<Container layout={{ type: 'vbox', pack: 'start' }} padding="0 0 0 15">
					{task && task.fields.map((item, index) => {
						switch (item.type) {
							case "attachment":
								return (
									<Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
										<Label cls="label" key={index} html={item.name + ': '} padding="12 0 12 0" />
										<Button ui="confirm round" iconCls="x-fa fa-file-pdf-o" cls="file-button" text="详情..." height="80%" handler={() => this.showFile({ path: item.path, ext: item.ext })} />
									</ Container>)
							case "groupAttachment":
								return (
									<Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
										<Label cls="label" key={index} html={item.name + ': '} />
										{item.children && item.children.map(
											(o, index) => (
												<Button key={index} ui="confirm round" cls="file-button" text={o.name} textAlign="left" handler={() => this.showFile({ path: o.path, ext: o.ext })} />
											)
										)}
									</Container>
								)
							case "tree":
								return (
									<TreeListView key={item.name} data={item.children} />
								)
							default:
								return (<Label cls="label" key={index} html={item.name + ': ' + item.value} padding="0 0 0 0" />)
						}
					})}
				</ Container>
				<Container layout={{ type: 'hbox', pack: 'space-around' }} padding="10 0 0 0">
					{[
						{ title: '审批通过', result: '提交' },
						{ title: '审批不通过', result: '驳回' }
					].map((o, i) => {
						return <Button
							ui="action raised"
							width="30%"
							handler={this.getShowMsgHandler(task, o.title, o.result)}
							text={o.result}
							key={i}
						/>
					})}
				</Container>
			</Panel>
		)
	}

	render() {
		const { match: { params: { id, type } } } = this.props
		const { allTaskList } = this.state

		if (!allTaskList)
			return <Message text="Loading..." />

		const task = allTaskList.find(o => o.type == type && o.id == id)
		if (!task)
			return <Message text="can't find this task" />

		const panelProps = {
			height: "100%",
			margin: '0 0 0 0',
			padding: '0 0 0 0'
		}

		return (
			<Panel shadow layout="vbox" {...panelProps}>
				<Container layout="fit" flex={0}>
					<MessageTitle title="审批详情" onClick={this.handleBack} />
				</Container>
				<Container layout="fit" flex={4}>
					{this.showTask(task)}
				</Container>
			</Panel>
		)
	}
}

const mapStateToProps = ({ }) => ({})
export default compose(
	connect(mapStateToProps, { doGetAllTaskList, doSubmitTask }),
)(DetailTask)